import { render, staticRenderFns } from "./DutyMatchingForm.vue?vue&type=template&id=6530fd2c"
import script from "./DutyMatchingForm.vue?vue&type=script&lang=js"
export * from "./DutyMatchingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports